if (customElements && !customElements.get('banner-with-info')) {
  class BannerWithInfo extends HTMLElement {
    constructor() {
      super();

      this.modelElement = this.querySelector('[data-role="3d-model-viewer"]');
    }

    connectedCallback() {
      this.init();
    }


    paralaxModalElement() {
      if (!this.modelElement) return;
      const container = this.querySelector('[data-role="container"]') ?? this

      gsap.fromTo(
        this.modelElement,
        {
          y: '-50%',
        },
        {
          y: () => container.offsetHeight * 0.5,
          ease: 'none',
          scrollTrigger: {
            trigger: container,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 1,
            invalidateOnRefresh: true,
          },
        }
      );
    }

    initAnimate() {
      if (typeof gsap === 'undefined') {
        console.error('Not found: GSAP');
        return;
      }

      this.paralaxModalElement();
    }

    init() {
      this.initAnimate();
    }
  }

  customElements.define('banner-with-info', BannerWithInfo);
}
